import React, { useEffect, useRef, useState } from "react";
import ePub from "epubjs";

const EpubReader = ({ fileUrl }) => {
  const viewerRef = useRef(null);
  const [rendition, setRendition] = useState(null);

  useEffect(() => {
    if (viewerRef.current) {
      const book = ePub(fileUrl);
      const newRendition = book.renderTo(viewerRef.current, {
        width: "100%",
        height: "100%",
      });

      newRendition.display();
      setRendition(newRendition);
    }
  }, [fileUrl]);

  const goToNextPage = () => {
    if (rendition) rendition.next();
  };

  const goToPreviousPage = () => {
    if (rendition) rendition.prev();
  };



}



export default EpubReader;
